module.exports = __webpack_public_path__ + "img/beer_id-110.6a1e71ea.png";